<div class="header-row" nz-row nzAlign="middle">
  <div nz-col nzSpan="16">
    <ng-content></ng-content>
  </div>
  <div nz-col class="right-content" nzSpan="8">
    <app-language-button></app-language-button>
    <app-user-profile-button [subTitle]="userSubTitle"></app-user-profile-button>
  </div>
</div>